import {
  FilePlus,
  Clock,
  Send,
  SearchCheck,
  Wrench,
  FileText,
} from "lucide-react";

const HowItWork = () => {
  const steps = [
    {
      title: "Submit Work Order",
      icon: <FilePlus className="w-8 h-8 text-blue-600" />,
      description: "Send us a request via email, portal, or integration.",
      detail: "✅ Response in 15 mins during business hours",
    },
    {
      title: "Dispatch Technician",
      icon: <Send className="w-8 h-8 text-green-600" />,
      description: "We assign the closest certified pro.",
      detail: "🚐 80% of jobs done within 24 hours",
    },
    {
      title: "Diagnosis & Estimate",
      icon: <SearchCheck className="w-8 h-8 text-yellow-500" />,
      description: "Transparent estimate sent after onsite check.",
      detail: "🔍 No surprise fees, pre-approved pricing",
    },
    {
      title: "Approval & Repair",
      icon: <Wrench className="w-8 h-8 text-red-500" />,
      description: "We repair after your approval & source parts if needed.",
      detail: "🔧 Warranty-grade service guaranteed",
    },
    {
      title: "Report & Invoice",
      icon: <FileText className="w-8 h-8 text-purple-500" />,
      description: "Photos, notes & invoice delivered digitally.",
      detail: "📑 Everything stored for your records",
    },
  ];

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-2">
          How It Works
        </h2>
        <p className="text-center text-gray-600 mb-10">
          Seamless, Transparent, and Reliable from Start to Finish
        </p>

        <div className="grid md:grid-cols-5 gap-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className="bg-white shadow rounded-2xl p-4 text-center flex flex-col items-center"
            >
              <div className="mb-2">{step.icon}</div>
              <h3 className="font-semibold text-sm">{step.title}</h3>
              <p className="text-xs text-gray-600">{step.description}</p>
              <p className="text-xs mt-1 text-gray-500 italic">{step.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWork;
